import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, apiErrorText } from "@/lib/api";
import {
  VLKPageHeader, VLKDataTable, VLKStatusBadge, VLKSelect, VLKUserAvatar, toast,
} from "@/components/vlk";
import { useAuth } from "@/context/AuthContext";

export default function Users() {
  const { user: me } = useAuth();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["users"], queryFn: () => api.get("/users").then(r => r.data) });
  const { data: roles } = useQuery({ queryKey: ["roles"], queryFn: () => api.get("/users/roles").then(r => r.data) });

  const canManage = me?.role === "system_admin";

  const changeRole = async (user_id, role) => {
    try {
      await api.patch(`/users/${user_id}/role`, { role });
      toast.success("Role updated");
      qc.invalidateQueries({ queryKey: ["users"] });
    } catch (e) { toast.error("Failed", { description: apiErrorText(e) }); }
  };

  return (
    <div>
      <VLKPageHeader title="Users & Roles" description="Directory of authorized operators. RBAC-controlled." />
      <VLKDataTable
        columns={[
          { key: "name", header: "Name", render: (r) => (
            <div className="flex items-center gap-2.5">
              <VLKUserAvatar name={r.name} src={r.avatar_url} size={28} />
              <span className="font-medium">{r.name}</span>
            </div>
          )},
          { key: "email", header: "Email", render: (r) => <span className="font-mono text-xs">{r.email}</span> },
          { key: "auth_method", header: "Method", render: (r) => <VLKStatusBadge status={r.auth_method === "google" ? "verified" : "active"}>{r.auth_method}</VLKStatusBadge> },
          { key: "role", header: "Role", render: (r) => canManage ? (
            <VLKSelect defaultValue={r.role} onChange={(e) => changeRole(r.user_id, e.target.value)} className="w-[220px]">
              {(roles?.roles || []).map((role) => <option key={role} value={role}>{role}</option>)}
            </VLKSelect>
          ) : <span className="font-mono text-xs uppercase tracking-widest">{r.role}</span> },
          { key: "created_at", header: "Created", mono: true, render: (r) => new Date(r.created_at).toLocaleDateString() },
        ]}
        rows={data?.items || []}
        rowKey={(r) => r.user_id}
        empty="No users yet."
      />
    </div>
  );
}
